// extracted by mini-css-extract-plugin
export default {"special_pricing_rule":"styles_special_pricing_rule__hmIzy","name":"styles_name__RNcXa"};